export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID || ''

export const pageView = (url: string) => {
  if (!window.hasOwnProperty('gtag') || !GA_TRACKING_ID) return

  //   @ts-ignore
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  })
}

export const event = ({
  action,
  category,
  label,
  value,
}: {
  action: string
  category: string
  label: string
  value: string
}) => {
  if (!window.hasOwnProperty('gtag') || !GA_TRACKING_ID) return

  //   @ts-ignore
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  })
}
